export default new class PopupAlertService {
    public showAlert(message: string, headerText?: string): Promise<void> {
        return new Promise((resolve) => {
            const dialog = this.createDialog();

            const header = document.createElement("div");
            header.className = "popup-header";
            const icon = document.createElement("i");
            icon.className = "fa fa-exclamation-circle";
            icon.setAttribute("aria-hidden", "true");
            icon.style.marginRight = "8px";
            header.appendChild(icon);
            header.appendChild(document.createTextNode(headerText ?? "Upozornění"));

            const messageBox = document.createElement("div");
            messageBox.className = "popup-message";
            messageBox.textContent = message;

            const buttons = document.createElement("div");
            buttons.className = "popup-buttons";
            const okButton = document.createElement("button");
            okButton.className = "btn btn-primary";
            okButton.textContent = "OK";
            buttons.appendChild(okButton);

            dialog.appendChild(header);
            dialog.appendChild(messageBox);
            dialog.appendChild(buttons);

            const closeDialog = (): void => {
                document.removeEventListener("keydown", onKeyDown);
                dialog.close();
            };
            const onKeyDown = (event: KeyboardEvent): void => {
                if (event.key === "Enter" || event.key === "Escape") {
                    event.preventDefault();
                    closeDialog();
                }
            };

            okButton.addEventListener("click", closeDialog);
            document.addEventListener("keydown", onKeyDown);

            dialog.addEventListener("close", () => {
                dialog.remove();
                resolve();
            });

            document.body.appendChild(dialog);
            dialog.showModal();
            okButton.focus();
        });
    }

    public showConfirm(
        message: string,
        headerText?: string,
        positiveButtonText?: string,
        negativeButtonText?: string,
    ): Promise<boolean> {
        return new Promise((resolve) => {
            const dialog = this.createDialog();

            const header = document.createElement("div");
            header.className = "popup-header";
            const icon = document.createElement("i");
            icon.className = "fa fa-question-circle";
            icon.setAttribute("aria-hidden", "true");
            icon.style.marginRight = "8px";
            header.appendChild(icon);
            header.appendChild(document.createTextNode(headerText ?? "Potvrzení"));

            const messageBox = document.createElement("div");
            messageBox.className = "popup-message";
            messageBox.innerHTML = message;

            const buttons = document.createElement("div");
            buttons.className = "popup-buttons";
            const yesButton = document.createElement("button");
            yesButton.className = "btn btn-primary";
            yesButton.textContent = positiveButtonText ?? "OK";
            const noButton = document.createElement("button");
            noButton.className = "btn btn-danger";
            noButton.textContent = negativeButtonText ?? "Zrušit";
            buttons.appendChild(yesButton);
            buttons.appendChild(noButton);

            dialog.appendChild(header);
            dialog.appendChild(messageBox);
            dialog.appendChild(buttons);

            const closeDialog = (result: boolean): void => {
                document.removeEventListener("keydown", onKeyDown);
                dialog.returnValue = result ? "yes" : "no";
                dialog.close();
            };
            const onKeyDown = (event: KeyboardEvent): void => {
                if (event.key === "Enter") {
                    event.preventDefault();
                    closeDialog(true);
                } else if (event.key === "Escape") {
                    event.preventDefault();
                    closeDialog(false);
                }
            };

            yesButton.addEventListener("click", () => closeDialog(true));
            noButton.addEventListener("click", () => closeDialog(false));
            document.addEventListener("keydown", onKeyDown);

            dialog.addEventListener("close", () => {
                const result = dialog.returnValue === "yes";
                dialog.remove();
                resolve(result);
            });

            document.body.appendChild(dialog);
            dialog.showModal();
            yesButton.focus();
        });
    }

    private createDialog(): HTMLDialogElement {
        const dialog = document.createElement("dialog");
        dialog.className = "popup-alert-dialog";

        return dialog;
    }
}();
